
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.388 4.037l-.107 6.03H4.136l-.107-6.03h1.36zm-.677 8.541a.807.807 0 01-.587-.24.785.785 0 01-.24-.586.767.767 0 01.24-.578.8.8 0 01.587-.244.79.79 0 01.578.244.796.796 0 01.128.995.854.854 0 01-.297.298.78.78 0 01-.41.111zm3.891-2.512v-.078c.006-.513.057-.92.153-1.224.1-.303.24-.548.422-.735.181-.187.4-.358.657-.512.165-.105.314-.222.446-.352.132-.13.237-.278.314-.446.077-.168.116-.354.116-.558 0-.245-.058-.457-.174-.636a1.156 1.156 0 00-.463-.413c-.19-.1-.402-.15-.636-.15-.212 0-.415.045-.607.133a1.15 1.15 0 00-.48.413c-.127.185-.2.423-.219.715H6.875c.02-.496.145-.914.376-1.256.231-.344.537-.605.917-.781a2.997 2.997 0 011.269-.265c.507 0 .95.096 1.33.286.38.187.676.45.885.789.212.336.318.729.318 1.178 0 .308-.048.586-.145.834a2.07 2.07 0 01-.413.657 2.82 2.82 0 01-.636.513 2.79 2.79 0 00-.57.454 1.446 1.446 0 00-.314.558c-.067.215-.102.48-.108.798v.078H8.602zm.624 2.512a.802.802 0 01-.582-.24.8.8 0 01-.244-.586c0-.226.081-.419.244-.578a.795.795 0 01.582-.244.79.79 0 01.579.244c.165.16.248.352.248.578 0 .152-.039.29-.116.417a.854.854 0 01-.298.298.788.788 0 01-.413.111z","fill":"#748190"}})])
          )
        }
      }
    